import { render, staticRenderFns } from "./FrzTypeCutPackingView.vue?vue&type=template&id=1b010c5b"
import script from "./FrzTypeCutPackingView.vue?vue&type=script&lang=js"
export * from "./FrzTypeCutPackingView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports